import react from 'react';
import './OpenTransactionsView.less';
import BrandIcon from '../BrandIcon/BrandIcon';
import {
  formatMoneyEuro,
  LocalizePropType,
  TransactionData,
  UserDataOutput,
} from 'getaway-data-layer';
import { Divider } from '@mui/material';
import React from 'react';

type Props = {
  localize: LocalizePropType;
  user: UserDataOutput;
  openTransactions: TransactionData[];
  onClickOpenInvoice: (url: string) => void;
  onClickPayOpenInvoice: (receiptNo: any) => void;
};

const OpenTransactionsView = ({
  localize,
  user,
  openTransactions,
  onClickPayOpenInvoice,
  onClickOpenInvoice,
}: Props) => {
  return (
    openTransactions?.length > 0 && (
      <div className="profile-tx-warning">
        <div className="profile-tx-warning-title">
          {localize(`profile.tx.open.title`)}
        </div>
        {openTransactions?.map((tx, index) => (
          <>
            <div key={tx?.id} className="profile-account-tx">
              <div
                className="profile-account-tx-nr"
                // @ts-ignore*
                onClick={() => onClickOpenInvoice(tx?.invoiceLink)}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src="/images/invoice.png"
                    alt="invoice"
                    style={{ width: 20, height: 20, marginRight: '12px' }}
                  />
                  {tx.receiptNo}
                </div>
                <BrandIcon name="search" style={{ width: 16, height: 16 }} />
              </div>
              <div
                className="profile-account-tx-action"
                onClick={() => onClickPayOpenInvoice(tx?.id)}
              >
                <div className="profile-account-tx-pay">
                  {localize('profile.tx.open.pay')}
                </div>
                <div className="profile-account-tx-amount-container">
                  <div className="profile-account-tx-amount">
                    {formatMoneyEuro(tx?.unpaidAmount || tx?.amount)}
                  </div>
                  <BrandIcon
                    name="arrowRight"
                    style={{ width: 16, height: 16, marginLeft: '8px' }}
                  />
                </div>
              </div>
            </div>
            {openTransactions?.length > 1 &&
              index !== openTransactions?.length - 1 && <Divider />}
          </>
        ))}
      </div>
    )
  );
};

export default OpenTransactionsView;
